var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styleOptions),on:{"click":function($event){return _vm.$emit('click')}}},[_c('x-icon',{class:_vm.iconClass,attrs:{"color":_vm.circleIconColor,"size":_vm.circleIconSize}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }